module.exports = __webpack_public_path__ + "img/chat_bubble_white.7c97c1a1.svg";